import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { LazyLoadView } from '@/router/utils'
import { isAuthenticated, WaitForAuthentication } from '../auth/authGuard'
import Modules from '@/router/modules'
import tracker from '@/tracking'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...Object.values(Modules).reduce((acc, val) => acc.concat(val), []),
    {
      name: 'dashboard',
      path: '/',
      props: true,
      component: () => import('@/views/Dashboard'),
      beforeEnter: isAuthenticated,
    },
    {
      name: 'dashboard-user',
      path: '/dashboard/:id',
      props: true,
      component: () => import('@/views/Dashboard'),
      beforeEnter: isAuthenticated,
    },
    {
      name: 'ads',
      path: '/ads',
      props: true,
      component: () => import('@/views/Ads'),
      beforeEnter: isAuthenticated,
    },
    {
      name: 'form',
      path: '/form',
      props: route => route.query,
      component: () => import('@/views/Form'),
      beforeEnter: isAuthenticated,
    },
    {
      name: 'signup',
      path: '/signup/:token',
      props: true,
      meta: {
        skipAuth: true,
      },
      component: () => LazyLoadView(import(/* webpackChunkName: "signup" */ '@/views/Signup.vue')),
    },
    {
      name: 'file-upload',
      path: '/file-upload',
      component: () => LazyLoadView(import(/* webpackChunkName: "file-upload" */ '@/views/FileUpload.vue')),
    },
    {
      name: 'logout',
      path: '/logout',
      meta: {
        skipVerification: true,
      },
      component: {
        created() {
          this.$auth.logout()
        },
      },
    },
    {
      name: 'account-agreement-awaiting',
      path: '/account-agreement/awaiting',
      props: true,
      meta: {
        navigation: false,
        footer: false,
        skipAuth: true,
      },
      component: () =>
        LazyLoadView(
          import(/* webpackChunkName: "account-agreement-awaiting" */ '@/views/AccountAgreement/Awaiting.vue'),
        ),
    },
    {
      name: 'account-agreement-sign',
      path: '/account-agreement/sign',
      props: true,
      meta: {
        navigation: false,
        footer: false,
        skipAuth: true,
      },
      component: () =>
        LazyLoadView(import(/* webpackChunkName: "account-agreement-sign" */ '@/views/AccountAgreement/Sign.vue')),
    },
    {
      name: 'request-access',
      path: '/request-access',
      props: true,
      meta: {
        navigation: false,
        footer: false,
        skipVerification: true,
      },
      component: () => LazyLoadView(import(/* webpackChunkName: "request-access" */ '@/views/RequestAccess.vue')),
      beforeEnter: async (to, from, next) => {
        let { isAuthenticated, isVerified } = await WaitForAuthentication()

        if (isAuthenticated && isVerified) return next({ name: 'dashboard' })
        if (isAuthenticated) return next()

        return next({ name: 'noaccess' })
      },
    },
    {
      name: 'noaccess',
      path: '/401',
      component: () => LazyLoadView(import(/* webpackChunkName: "noaccess" */ '@/views/NoAccess.vue')),
      meta: {
        skipAuth: true,
      },
    },
    {
      name: 'notfound',
      path: '/404',
      component: () => LazyLoadView(import(/* webpackChunkName: "notfound" */ '@/views/404.vue')),
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  router.app.$previousRoute = from
  next()
})

router.afterEach((to, from) => {
  // dont track changes when query params changes ( filter )
  if (to.name === from.name && to.path === from.path) return

  tracker.emit('Route:navigation', to)
})

export default router
